module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gITDy4TK9G09wAAAQ1JREFUKM+d070uBVEUxfHfnPi4OqbTiF6UI3GC2jsoSFS8hcRrUEg8AQ8gwfiYW9IqiWYqEcmVXIU9pTBWc5rz3+esvdcu2iYrqxq0TZ5BhR2sYA4t7nCCYVnV722TQSHUNnkZB9jEO0YYI2ECA5zjsKzqh7bJ33CAR1jEp581hSfsl1U9LOKrp1j7BexU4Aa7Kbxt/hEUVjLWErbDYx9NYqN7edQTHiGnGMe4JzzGfIo5pp5wgZcUAZj4h+erFMkZ9IQ/cJkwxFkE4K9fvsdFl7AlHGPhl+YVeMVWWdWPKRbjEXu4jgvT0cQizukoetuBbZMV3YaUVa1t8mzEdB2rmMcz6ih8UVb1W7eJX+RxVgnMLW3mAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/yellow_marker.png
// module id = 581
// module chunks = 13